import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';

import { SearchService } from '@app/core/services/search.service';
import { UserService } from '@app/core/services/user.service';
import { AuthComponentModule } from '@app/shared/components/auth/auth.component.module';
import { BackButtonComponentModule } from '@app/shared/components/back-button/back-button.component.module';
import { GdrpPopupComponentModule } from '@app/shared/components/gdrp-popup/gdrp-popup.component.module';
import { TripPlanComponentModule } from '@app/shared/components/trip-plan/trip-plan.component.module';
import { YourCouponsComponentModule } from '@app/shared/components/your-coupons/your-coupons.component.module';
import { YourTicketsComponentModule } from '@app/shared/components/your-tickets/your-tickets.component.module';
import { ClusterApiService, PlaceApiService } from '@app/shared/services/api';
import { CoreHeaderComponent } from './components/core-header/core-header.component';
import { SearchComponent } from './components/search/search.component';
import { UserBlockComponent } from './components/user-block/user-block.component';
import { WlHeaderComponent } from './components/wl-header/wl-header.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ClickOutsideModule,
    TranslateModule,
    AuthComponentModule,
    GdrpPopupComponentModule,
    YourCouponsComponentModule,
    TripPlanComponentModule,
    BackButtonComponentModule,
    YourTicketsComponentModule,
  ],
  exports: [CoreHeaderComponent, WlHeaderComponent],
  declarations: [
    CoreHeaderComponent,
    SearchComponent,
    UserBlockComponent,
    WlHeaderComponent,
  ],
  providers: [UserService, SearchService, ClusterApiService, PlaceApiService],
})
export class CoreModule {}
